export default "__VITE_ASSET__pRIxAG2IYbO54rXFvEKnLQ__"